import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-notifications',
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
